const $ = jQuery

export default function Hubspot () {
  $(document).on('click', '.hs-submit input[type="submit"]', function() {
    const FORM = $(this).closest('.hs-form')
    const CHECKBOX = FORM.find('.legal-consent-container input[type="checkbox"]')
    if (CHECKBOX.length > 0) {
      setActive(CHECKBOX[0])
    }
  })
  $(document).on('change', '.legal-consent-container input[type="checkbox"]', function() {
    setActive(this)
  })
}

function setActive (checkbox) {
  if (checkbox.checked) {
    checkbox.parentNode.classList.remove('invalid')
  } else {
    checkbox.parentNode.classList.add('invalid')
  }
}